var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 text-center min-vh-100"},[_c('h1',{staticClass:"h3 mt-5 mb-3"},[_c('strong',[_c('img',{attrs:{"src":"/assets/img/loading.svg"}})])])])
}]

export { render, staticRenderFns }